import { ConsentGroups } from './Constants';

const storageConsent = {
  localStorage: {
    showPlanningIds: ConsentGroups.strictlyNecessary,
    activeVisitor: ConsentGroups.functional,
    lastVisitedExhibitor: ConsentGroups.functional,
    cta: ConsentGroups.strictlyNecessary,
    cta_products: ConsentGroups.strictlyNecessary,
    fromEditProfile: ConsentGroups.functional,
    viewedProductVideosBanner: ConsentGroups.functional,
  },
  sessionStorage: {
    isParticipationEvent: ConsentGroups.strictlyNecessary,
    surveyClosed: ConsentGroups.functional,
    isSalesTeamNotifiedForLeadBoosterUpsell: ConsentGroups.functional,
  },
};

const getCookieName = (storageType, key) =>
  `${storageType === 'localStorage' ? 'otls' : 'otss'}_${key}`;

let initialized = false;
let lastActiveGroups;

const syncConsentCookies = () => {
  const activeGroups = window.OnetrustActiveGroups;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  Object.entries(storageConsent).forEach(([storageType, keys]) => {
    Object.entries(keys).forEach(([key, group]) => {
      const granted = group === ConsentGroups.strictlyNecessary ||
        (typeof activeGroups === 'string' && activeGroups.includes(`,${group},`));
      document.cookie = `${getCookieName(storageType, key)}=${granted}; Path=/; SameSite=Lax${secure}`;
    });
  });
  lastActiveGroups = activeGroups;
};

const initialize = () => {
  if (typeof window === 'undefined' || !window.document) {
    return;
  }

  if (!initialized) {
    window.addEventListener('OneTrustGroupsUpdated', syncConsentCookies);
    window.addEventListener('OTConsentApplied', syncConsentCookies);
    initialized = true;
    syncConsentCookies();
  } else if (lastActiveGroups !== window.OnetrustActiveGroups) {
    syncConsentCookies();
  }
};

const hasStorageConsent = (storageType, key) => {
  if (!Object.prototype.hasOwnProperty.call(storageConsent[storageType], key)) {
    return true;
  }

  initialize();

  // Do not recreate a removed or rejected control cookie during storage access.
  const cookie = `${getCookieName(storageType, key)}=true`;
  return document.cookie.split(';').some((entry) => entry.trim() === cookie);
};

const getItem = (storageType, key) =>
  hasStorageConsent(storageType, key) ? window[storageType].getItem(key) : null;

const setItem = (storageType, key, value) => {
  if (hasStorageConsent(storageType, key)) {
    window[storageType].setItem(key, value);
  }
};

export default { initialize, getItem, setItem };
